import client from './client'

export default {
  async getEcology (id) {
    const url = `/quanzi/${id}/homepage`
    const res = await client.get(url)
    return res.data.data
  },
  async getEcologyPost (id, page = 1, limit = 10) {
    const url = `/quanzi/posts/list/${id}`
    const res = await client.get(url, {
      params: {
        page, limit
      }
    })
    return res.data.data
  }
}



// WEBPACK FOOTER //
// ./src/apis/ultron-api/ecology.js